module.exports = "/_next/static/images/Frame2-e9dcbed11b08b8077e7045260c5f1303.webp";